import React from 'react';
import AdminLayout from '../components/admin/AdminLayout';
import MyCalendar from '../components/admin/MyCalendar';

const AdminCalendarPage: React.FC = () => {
  return (
    <AdminLayout>
      <MyCalendar />
    </AdminLayout>
  );
};

export default AdminCalendarPage;